import {
  appRedirect,
  renderPrice,
  setModal,
  toggleModal,
  toggleOnboarding,
  updateBillingAddon
} from "app/NativeActions";
import { Card, Title, Wrapper } from "app/NativeComponents/common";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import BillingAddonItem from "./BillingAddonItem";

const BillingAddons = () => {
  const dispatch = useDispatch();
  const { token, user } = useSelector(({ auth }) => auth);
  const { platform } = useSelector(({ native }) => native);
  const { colors } = useSelector(({ settings }) => settings);
  const { card_info, billing_addons } = useSelector(({ billing }) => billing);

  if (platform != "ios" && billing_addons) {
    if (
      (user.team_clearance_level > 0 || user.team_owner == 1) &&
      billing_addons.length > 0
    ) {
      return (
        <Wrapper>
          <Wrapper style={{ padding: 20 }}>
            <Title>Add-ons: </Title>
          </Wrapper>
          <Card>
            {billing_addons.map((addon, i) => {
              return (
                <BillingAddonItem
                  key={i}
                  addon={addon}
                  price={addon.monthly_price}
                  colors={colors}
                  onPurchaseItem={() => {
                    //show pop up to confirm purcahse and explain how they'll be charged
                    if (card_info.has_card) {
                      dispatch(
                        setModal({
                          title: "Purchase add-on",
                          description:
                            "Are you sure you want to purchase this add-on? You will receive a pro-rated charge today. On your next billing cycle you will be charged " +
                            renderPrice(addon.monthly_price) +
                            ".",
                          icon: "check",
                          submit: "Confirm Purchase",
                          onPress: () => {
                            dispatch(
                              updateBillingAddon({
                                token: token,
                                type: "purchase",
                                slug: addon.slug,
                                addon_id: addon.id
                              })
                            );
                          },
                          cancel: "Not right now",
                          onCancel: () => {}
                        })
                      );
                      dispatch(toggleModal({ show: true, type: "normal" }));
                    } else {
                      appRedirect({ redirect: "cardOnFile" });
                    }
                  }}
                  onCancelItem={() => {
                    //show pop up to confirm cancel
                    dispatch(
                      setModal({
                        title: "Cancel Product",
                        description:
                          "Are you sure you want to cancel this product? You will no longer have access and any automations will turn off.",
                        icon: "error",
                        submit: "Confirm Cancelation",
                        buttonType: "destroy",
                        onPress: () => {
                          //trigger cancelBillingAddon
                          dispatch(
                            updateBillingAddon({
                              token: token,
                              type: "cancel",
                              addon_id: addon.id,
                              slug: addon.slug
                            })
                          );
                        },
                        cancel: "Not right now",
                        onCancel: () => {}
                      })
                    );
                    dispatch(toggleOnboarding(true));
                    dispatch(toggleModal({ show: true, type: "normal" }));
                  }}
                />
              );
            })}
          </Card>
        </Wrapper>
      );
    }
  }

  return <Wrapper />;
};

export default BillingAddons;
